const onclicks = new Map();
const hrefs = new Map();
const tabIndices = new Map();
const classNames = new Map();

const clickNoop = (): boolean => false;

export const propStore = {
    backup: (element, disabledClass?: string): void => {
        if (!onclicks.has(element) && element.onclick) {
            onclicks.set(element, element.onclick);
            element.onclick = clickNoop;
        }

        if (!hrefs.has(element) && element.getAttribute('href')) {
            hrefs.set(element, element.getAttribute('href'));
            element.removeAttribute('href');
        }

        if (!tabIndices.has(element) && element.tabIndex !== 1) {
            tabIndices.set(element, element.tabIndex);
            element.tabIndex = '-1';
        }

        if (disabledClass) {
            classNames.set(element, element.className);
            element.className = disabledClass;
        }
    },
    restore: (element): void => {
        if (onclicks.has(element)) {
            element.onclick = onclicks.get(element);
            onclicks.delete(element);
        }

        if (hrefs.has(element)) {
            element.setAttribute('href', hrefs.get(element));
            hrefs.delete(element);
        }

        if (tabIndices.has(element)) {
            element.tabIndex = tabIndices.get(element);
            tabIndices.delete(element);
        }

        if (classNames.has(element)) {
            element.className = classNames.get(element);
            classNames.delete(element);
        }
    },
};


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/element-disabler/src/util.ts